(function () {
  'use strict';

  angular
    .module('hq.tools.lighting')
    .provider('hqTLightingLanguage', LanguageProvider);

  /**
   * @ngdoc service
   * @module hq.tools.lighting
   * @name hqTLightingLanguageProvider
   * @description Provide application language during configuration.
   * @requires $translateProvider
   * @example
   * <pre>
   * app.config(function(hqTLightingLanguageProvider) {
   *   hqTLightingLanguageProvider
   *     .updateLanguageFromHtml()
   *     .setPreferedLanguage();
   * });
   * </pre>
   */
  function LanguageProvider(
    $translateProvider,
    THEME_BASE_PATH,
    THEME_TITLE,
    TRANSLATIONS_PREFIX
  ) {
    'ngInject';

    var _this = this;

    /**
     * @ngdoc property
     * @name currentLanguage
     * @propertyOf hqTLightingLanguageProvider
     * @returns {String} Language key
     * @description Current language key. E.g., 'en'
     */
    _this.defaultLanguage = 'fr';
    _this.currentLanguage = _this.defaultLanguage;

    _this.registerAvailableLanguages = function () {
      $translateProvider.registerAvailableLanguageKeys(['en', 'fr']);
      return _this;
    };

    _this.setSanitizeStrategy = function () {
      return _this;
    };

    _this.loadJson = function () {
      $translateProvider.useStaticFilesLoader({
        prefix: THEME_BASE_PATH + THEME_TITLE + TRANSLATIONS_PREFIX,
        suffix: '.json',
      });
      return _this;
    };

    /**
     * @ngdoc method
     * @name setPreferedLanguage
     * @methodOf hqTLightingLanguageProvider
     * @description Set app's default language. This should be done in the config stage.
     * @returns {hqTLightingLanguageProvider} Returns self for chaining
     * @example
     * <pre>
     * hqTLightingLanguageProvider.setPreferedLanguage();
     * </pre>
     */
    _this.setPreferedLanguage = function () {
      $translateProvider.preferredLanguage(_this.currentLanguage);
      return _this;
    };

    /**
     * @ngdoc method
     * @name updateLanguageFromHtml
     * @methodOf hqTLightingLanguageProvider
     * @description Get's language from <html lang="">
     * @returns {hqTLightingLanguageProvider} Returns self for chaining
     * @example
     * <pre>
     * hqTLightingLanguageProvider.updateLanguageFromHtml();
     * </pre>
     */
    _this.updateLanguageFromHtml = function () {
      if (angular.element(document.documentElement).attr('lang')) {
        _this.currentLanguage = angular
          .element(document.documentElement)
          .attr('lang')
          .slice(0, 2);
      }
      return _this;
    };

    _this.$get = function languageFactory() {
      /**
       * @ngdoc service
       * @module hq.tools.lighting
       * @name hqTLightingLanguage
       * @description Application language service
       */

      /**
       * @ngdoc property
       * @propertyOf hqTLightingLanguage
       * @name currentLanguage
       * @description Get current language. Setting this property will have no effect.
       * @returns {String} Language key
       * @example
       * <pre>
       * var lang = hqTLightingLanguage.currentLanguage;
       * console.log(lang); // E.g., 'en'
       * </pre>
       */
      return {
        currentLanguage: _this.currentLanguage,
      };
    };
  }
}());
